

import { pdMixin } from '@/mixin/pd/pdMixin'
import ScrPdr000c8 from '@/components/pd/pdr/SCR_PDR_000C_8.vue'
import { convertHtmlImage } from '~/scriptData/common/convertHtmlImage'

export default {
  components: {
    ScrPdr000c8
  },
  mixins: [pdMixin],
  props: {
    pdDesc: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pdUnit: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isOpt: {
      type: Boolean,
      default: false
    },
    pdNo: {
      type: String,
      default: ''
    },
    viewType: {
      type: String,
      default: ''
    },
    exhCtgr: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      mdNoti: [], // MD공지
      pdDtlBrnd: {}, // 브랜드
      pdDtlDc: '', // 상품 설명
      qltyCtfc: [], // 품질인증
      tqcNoti: [], // TQC공지
      detailHei: false, // 상품설명 접기/펼치기 여부
      visualPdDtlDc: '', // 상품설명_시작정보
      selectOpt: '',
    }
  },
  computed: {
    // 상품상세 설명
    editorHtml () {
      const parser = new DOMParser()
      const el = parser.parseFromString(this.pdDtlDc, 'text/html')
      return this.visualPdDtlDc !== '' ? convertHtmlImage({ innerText: this.replaceAlt(el.body.innerText), videoResize: '_mute_360p', videoWidth: '100%' }) : this.pdDtlDc ? convertHtmlImage({ innerText: el.body.innerText, videoResize: '_mute_360p', videoWidth: '100%' }) : '' // 상품상세설명 빈값일 때 null 노출 방어
    },
    // md공지
    mdNotiHtml () {
      const parser = new DOMParser()
      let returnHtml = ''
      this.mdNoti.forEach((item) => {
        const el = parser.parseFromString(item.notiCn, 'text/html')
        returnHtml = returnHtml + el.body.innerText
      })
      return returnHtml
    },

    // tqc공지
    tqcNotiHtml () {
      const parser = new DOMParser()
      let returnHtml = ''
      this.tqcNoti.forEach((item) => {
        const el = parser.parseFromString(item.notiCn, 'text/html')
        returnHtml = returnHtml + el.body.innerText
      })
      return returnHtml
    },
  },
  mounted () {
    const data = this.pdDesc.data
    this.pdDtlDc = data.pdDtlDesc.pdDtlDc // 상품 설명
    this.qltyCtfc = data.pdDtlDesc.qltyCtfc // 품질인증 정보

    if (data.pdDtlDesc.visualInfoCd === '02') {
      this.visualPdDtlDc = this.decodeHtmlEntities(data.pdDtlDesc.visualPdDtlDc)
    }

    if (this.isNotEmpty(data.pdDtlDesc.brnd)) {
      this.pdDtlBrnd = data.pdDtlDesc.brnd // 브랜드 정보 셋팅
    }

    if (this.isNotEmpty(data.pdDtlNoti)) {
      this.mdNoti = data.pdDtlNoti.filter(o => o.postLcCd === '01') // md 공지
      this.tqcNoti = data.pdDtlNoti.filter(o => o.postLcCd === '02') // TQC 공지
    }
  },
  methods: {
    // 23.08.21 퍼블 함수 수정, 버튼 클래스/텍스트 변경
    heiSet () {
      this.detailHei = !this.detailHei
    },
    replaceAlt (innerText) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(innerText, 'text/html')
      const images = Array.from(doc.getElementsByTagName('img'))
      images.forEach((img) => {
        img.setAttribute('alt', this.visualPdDtlDc)
      })
      return doc.body.innerHTML
    },
    decodeHtmlEntities (html) {
      const parser = new DOMParser()
      const decodedString = parser.parseFromString(html, 'text/html').documentElement.textContent
      return decodedString
    },
    moveCs () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      // 마이페이지 >  고객 센터-문의하기 cs/csl/SCR_CSL_0001
      this.$router.push({ path: '/cs/csl/SCR_CSL_0001', query: { compPdNo: this.isOpt ? this.selectOpt : (this.pdUnit?.pdTy === '06' ? this.pdUnit?.onldOpt?.[0]?.pdNo : this.pdNo) } })
    }

    // moreBtn () {
    // // 더보기 버튼 노출
    //   let innerHeight = 0
    //   document.querySelectorAll('.cms > div').forEach((el) => {
    //     innerHeight += el.clientHeight
    //     // 내부 컨텐츠 높이가 500보다 작으면 더보기 버튼 제거 및 높이 자동 설정
    //     this.showDetailBtn = innerHeight > 500
    //     this.detailHei = !this.showDetailBtn
    //     console.log(innerHeight, this.showDetailBtn, this.detailHei)
    //   })
    // }
  }
}
